<script setup lang="ts">
  import type { Paginator } from '@othercommerce/domain';
  import type { ListOrderItemResource, OrderResource } from '@storefront/resources';

  interface Props {
    products: Paginator<ListOrderItemResource>;
    order?: OrderResource;
    complaint: string;
    back: string;
  }

  defineOptions({
    inheritAttrs: false,
  });

  defineProps<Props>();
</script>
<template>
  <main id="main" class="complaint">
    <ComplaintProductsView v-bind="$props" />
  </main>

  <RouterView />
</template>
<style scoped lang="scss">
  @use "@storefront/styles/mixins/media";

  .complaint {
    width: 98%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 60px 0 100px;
    min-height: calc(100dvh - 198px);
  }

  @include media.query(lg) {
    .complaint {
      padding: 2rem 0;
      width: 100%;
      min-height: calc(100dvh - 229px);

    }
  }
</style>